import client from '../../providers/fetchClient'

export const processCampaignPledges = campaign_id => client.post('/v3/orders/process', { campaign_id })

export const getOrders = params => client.get('/v3/orders', { params })
